import { render, staticRenderFns } from "./valuations.vue?vue&type=template&id=1d961b19&scoped=true&"
import script from "./valuations.vue?vue&type=script&lang=js&"
export * from "./valuations.vue?vue&type=script&lang=js&"
import style0 from "./valuations.vue?vue&type=style&index=0&id=1d961b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d961b19",
  null
  
)

export default component.exports